'use strict';

var googleSlots = {};
var definedSlotIds = [];

module.exports = {
	googleAdSlots: googleSlots,
	definedAdSlotIds: definedSlotIds
};